import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAuth } from '../../contexts/auth';

interface Props {
  className?: string;
}

const LeaveButton = ({ className }: Props) => {
  const classes = useStyles();
  const { logout } = useAuth();

  return (
    <Hidden smUp>
      <Box className={[classes.leaveButtonContainer, className].join(' ')}>
        <Button startIcon={<span>👋</span>} onClick={logout}>
          Sair
      </Button>
      </Box>
    </Hidden>
  );
}

export default LeaveButton;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    leaveButtonContainer: {
      position: 'absolute',
      right: 10,

      '@media (min-height: 680px)': {
        bottom: 10,
      },

      '& button': {
        color: 'red',
        fontSize: 16,
      },
    },
  })
);